import React from "react";
import styled, { css } from "react-emotion";
import { Container, Col, Row } from "reactstrap";

const dynamicColor = props =>
  css`
    background-color: ${props.color} !important;
  `;

const CalloutElement = styled("div")`
  width: 100%;
  ${dynamicColor};
  text-transform: uppercase;
  color: #ffffff !important;
  font-size: 22px;
  font-weight: 100;
  text-align: center;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default class CalloutGrid extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment className="d-none d-md-block">
        <Row className="mt-4">
          <Col md="4">
            <CalloutElement color={"#8ca2d4"}>Naturstein</CalloutElement>
          </Col>
          <Col md={{ size: 4, offset: 4 }}>
            <CalloutElement color={"#bcc5e6"}>Keramik</CalloutElement>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 4, offset: 3 }}>
            <CalloutElement color={"#0055a4"}>Kunststein</CalloutElement>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/calloutgrid.js